const ITEM_SELECTOR = '.jdgm-carousel-item';

function firstText(element, selectors) {
  for (const selector of selectors) {
    const value = element.querySelector(selector)?.textContent?.replace(/\s+/g, ' ').trim();
    if (value) return value;
  }
  return '';
}

function getReviewScore(item) {
  const rating = item.querySelector('.jdgm-carousel-item__review-rating, [data-score]');
  const score = Number.parseFloat(rating?.getAttribute('data-score') || '');
  if (Number.isFinite(score)) return Math.min(5, Math.max(0, score));

  const fullStars = item.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star[class*="jdgm--on"]').length;
  const halfStars = item.querySelectorAll('.jdgm-star.jdgm--half, .jdgm-star[class*="jdgm--half"]').length;
  return Math.min(5, fullStars + halfStars * 0.5);
}

function createStars(score) {
  const rating = document.createElement('div');
  rating.className = 'review-card__rating';
  rating.setAttribute('role', 'img');
  rating.setAttribute('aria-label', `${score.toLocaleString('pt-BR')} de 5 estrelas`);

  for (let index = 1; index <= 5; index += 1) {
    const star = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    star.setAttribute('width', '16');
    star.setAttribute('height', '16');
    star.setAttribute('viewBox', '0 0 24 24');
    star.setAttribute('aria-hidden', 'true');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M12 2.5L14.94 8.46L21.52 9.42L16.76 14.06L17.88 20.62L12 17.53L6.12 20.62L7.24 14.06L2.48 9.42L9.06 8.46L12 2.5Z');
    path.setAttribute('fill', index <= Math.round(score) ? '#F5A000' : '#DDE3E8');
    star.append(path);
    rating.append(star);
  }

  return rating;
}

function createReviewSlide(sourceItem, index) {
  const title = firstText(sourceItem, ['.jdgm-carousel-item__review-title', '.jdgm-rev__title']);
  const body = firstText(sourceItem, [
    '.jdgm-carousel-item__review-body',
    '.jdgm-carousel-item__review-content',
    '.jdgm-rev__body',
  ]);
  const author = firstText(sourceItem, [
    '.jdgm-carousel-item__reviewer-name',
    '.jdgm-carousel-item__reviewer-name-wrapper',
    '.jdgm-rev__author',
  ]) || 'Cliente verificado';
  const product = firstText(sourceItem, [
    '.jdgm-carousel-item__product-title',
    '.jdgm-carousel-item__product-name',
    '.jdgm-carousel-item__product',
  ]);
  const score = getReviewScore(sourceItem) || 5;
  const reviewText = [title, body].filter(Boolean).join(' — ');

  if (!reviewText) return null;

  const slide = document.createElement('div');
  slide.className = 'swiper-slide';
  slide.dataset.reviewIndex = String(index);

  const article = document.createElement('article');
  article.className = 'review-card';
  article.setAttribute('aria-label', `Avaliação de ${author}`);

  const content = document.createElement('div');
  content.className = 'review-card__content';
  content.append(createStars(score));

  const quote = document.createElement('blockquote');
  quote.className = 'review-card__quote';
  const paragraph = document.createElement('p');
  paragraph.textContent = reviewText;
  quote.append(paragraph);
  content.append(quote);

  const footer = document.createElement('footer');
  footer.className = 'review-card__author';
  const name = document.createElement('cite');
  name.className = 'review-card__name';
  name.textContent = author;
  footer.append(name);

  if (product) {
    const productName = document.createElement('span');
    productName.className = 'review-card__region';
    productName.textContent = ` — ${product}`;
    footer.append(productName);
  }

  content.append(footer);
  article.append(content);
  slide.append(article);
  return slide;
}

function buildReviewsCarousel(section) {
  if (section.dataset.initialized === 'true') return true;

  const source = section.querySelector('[data-judgeme-carousel-source]');
  const swiperElement = section.querySelector('[data-reviews-carousel-swiper]');
  const wrapper = section.querySelector('[data-reviews-carousel-wrapper]');
  const status = section.querySelector('[data-reviews-status]');

  if (!(source instanceof HTMLElement) || !(swiperElement instanceof HTMLElement) || !(wrapper instanceof HTMLElement)) {
    return false;
  }

  const sourceItems = [...source.querySelectorAll(ITEM_SELECTOR)];
  const slides = sourceItems.map(createReviewSlide).filter((slide) => slide instanceof HTMLElement);
  if (!slides.length || typeof window.Swiper !== 'function') return false;

  wrapper.replaceChildren(...slides);
  swiperElement.hidden = false;
  if (status instanceof HTMLElement) status.hidden = true;

  const controls = section.querySelector('[data-reviews-controls]');
  if (controls instanceof HTMLElement) controls.hidden = slides.length <= 3;

  section.dataset.initialized = 'true';
  section.reviewsCarouselSwiper = new window.Swiper(swiperElement, {
    slidesPerView: 1.15,
    spaceBetween: 20,
    loop: section.dataset.loop === 'true' && slides.length > 3,
    watchOverflow: true,
    keyboard: { enabled: true, onlyInViewport: true },
    a11y: { enabled: true },
    navigation: {
      nextEl: section.querySelector('[data-reviews-carousel-next]'),
      prevEl: section.querySelector('[data-reviews-carousel-prev]'),
    },
    breakpoints: {
      750: { slidesPerView: 2 },
      994: { slidesPerView: 3 },
    },
    observer: true,
    observeParents: true,
  });

  return true;
}

function initializeReviewsCarousel(section) {
  if (buildReviewsCarousel(section)) return;
  if (section.dataset.loading === 'true') return;
  section.dataset.loading = 'true';

  const source = section.querySelector('[data-judgeme-carousel-source]');
  const status = section.querySelector('[data-reviews-status]');
  if (!(source instanceof HTMLElement)) return;

  let retryTimer;
  const finish = () => {
    observer.disconnect();
    window.clearInterval(retryTimer);
    delete section.dataset.loading;
  };

  const observer = new MutationObserver(() => {
    if (!buildReviewsCarousel(section)) return;
    finish();
  });
  observer.observe(source, { childList: true, subtree: true });

  retryTimer = window.setInterval(() => {
    if (!buildReviewsCarousel(section)) return;
    finish();
  }, 250);

  window.setTimeout(() => {
    finish();
    if (section.dataset.initialized === 'true' || !(status instanceof HTMLElement)) return;
    status.textContent = 'Nenhuma avaliação em destaque foi encontrada no Judge.me.';
  }, 8000);
}

function initializeReviewsCarousels(scope = document) {
  scope.querySelectorAll('[data-reviews-carousel]').forEach((section) => {
    if (section instanceof HTMLElement) initializeReviewsCarousel(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeReviewsCarousels(), { once: true });
} else {
  initializeReviewsCarousels();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeReviewsCarousels(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target instanceof Element ? event.target.querySelector('[data-reviews-carousel]') : null;
  section?.reviewsCarouselSwiper?.destroy(true, true);
});
